import Close from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import Box, { BoxProps } from '@mui/material/Box';
import { StyledModalBox } from '@styled/modal';
import React, { PropsWithChildren } from 'react';

type ModalBoxProps = BoxProps & {
  handleClose: () => void;
};

const ModalBox = React.forwardRef(
  (
    { handleClose, children, ...props }: PropsWithChildren<ModalBoxProps>,
    ref,
  ) => {
    return (
      <Backdrop open>
        <StyledModalBox
          display='flex'
          flexDirection='column'
          ref={ref}
          {...props}
        >
          <Box width='100%' display='flex' justifyContent='flex-end'>
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </Box>
          <Box px={4} pb={4}>
            {children}
          </Box>
        </StyledModalBox>
      </Backdrop>
    );
  },
);

ModalBox.displayName = 'ModalBox';

export default ModalBox;
